import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CreateLayeredMapModalContainer, type CreateLayeredMapProps,
} from './createLayeredMapModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CreateLayeredMap: CreateLayeredMapProps;
  }
}
modalRenderer.register('CreateLayeredMap', CreateLayeredMapModalContainer);
